var pjson = require('../../package.json');
export default Object.freeze({
    DRUGS_INFO_DEFAULT_TAB: 0,
    DRUGS_PRODUCT_TAB: 3,
    GENERIC_HUMAN_PRODUCT: 'generic',
    CLICK_WORD: 'clique',
    NACIONALITY: 'brazilian',
    LOCALE: 'pt-BR',
    APP_VERSION: `${pjson.version}`,
    VERSION: pjson.version,
    FORBIDDEN_APP_VERSION: 1,
    OUTDATED_APP_VERSION: 2,
    OK_APP_VERSION: 0,
    APP_ON_PLAY_STORE: "https://play.google.com/store/apps/details?id=br.com.vetalfa",
    APP_ON_APPLE_STORE: "https://apps.apple.com/us/app/vet-alfa/id1542661563",
    DRUGS_MISC_CLASS: 'Diversos',
    HOME_URL: "https://vetalfa.com",
    TERMS_URL: "https://vetalfa.com/terms",
    LOGIN_CHANGE: "https://vetalfa.com/login-change",
    POLICIES_URL: "https://vetalfa.com/policies",
    INSTAGRAM_LINK: 'https://www.instagram.com/vetalfaapp/',
});